(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-deals-live-tv"] && !Shopify.designMode) return;
  try {
    
  function initBestDealsCarousel() {
    var carousels = document.querySelectorAll('.best-deals-live-tv__carousel');
    
    carousels.forEach(function(carousel) {
      if (carousel.dataset.bestDealsInit) return;
      carousel.dataset.bestDealsInit = 'true';

      var sectionId = carousel.id.replace('best-deals-carousel-', '');
      var buttons = document.querySelectorAll('[data-best-deals-carousel-button="' + sectionId + '"]');

      function getScrollAmount() {
        var card = carousel.querySelector('.best-deals-live-tv__card');
        if (!card) return carousel.clientWidth / 2;
        
        var style = window.getComputedStyle(carousel);
        var gap = parseInt(style.gap) || 24;
        return card.offsetWidth + gap;
      }

      buttons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          var direction = button.dataset.direction === 'right' ? 1 : -1;
          var scrollAmount = getScrollAmount();
          
          carousel.scrollBy({
            left: direction * scrollAmount,
            behavior: 'smooth'
          });
        });
      });
    });
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBestDealsCarousel);
  } else {
    initBestDealsCarousel();
  }

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('best-deals-live-tv')) {
      initBestDealsCarousel();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lgd-top-section"] && !Shopify.designMode) return;
  try {
    
function initHeroBanners() {
    const heroes = document.querySelectorAll(".spy-plp-conatiner .hero");
    heroes.forEach(hero => {
        if (hero.dataset.sliderInit === "1") return;

        const cards = hero.closest('.spy-plp-conatiner').querySelectorAll(".product-card");
        if (!cards.length) return;

        hero.dataset.sliderInit = "1";
        const sectionId = hero.dataset.sectionId;

        const allDesktopBgs = [];
        const allMobileBgs = [];
        cards.forEach(card => {
            if (card.dataset.bgDesktop) allDesktopBgs.push(card.dataset.bgDesktop);
            if (card.dataset.bgMobile) allMobileBgs.push(card.dataset.bgMobile);
        });

        const SLIDE_COUNT = cards.length;
        const INTERVAL_MS = parseInt(hero.dataset.rotatorSpeed) || 3000;
        let index = 0;
        let timer = null;

        const getPreloadImages = (mainOnly) => {
            const isMobile = window.innerWidth <= 991;
            if (mainOnly) {
                return isMobile ? allMobileBgs : allDesktopBgs;
            }
            return isMobile ? allDesktopBgs : allMobileBgs;
        };

        function preload(urls) {
            return Promise.all(urls.map(src => {
                const img = new Image();
                img.src = src;
                return img.decode ? img.decode().catch(() => {})
                    : new Promise(res => { img.onload = img.onerror = res; });
            }));
        }

        function render() {
            const activeCard = cards[index % cards.length];
            const isMobile = window.innerWidth <= 991;
            if (window.innerWidth >= 768) {
              const customBg = isMobile ? activeCard.dataset.bgMobile : activeCard.dataset.bgDesktop;
              hero.style.backgroundImage = customBg ? `url("${customBg}")` : '';
            } else {
              hero.style.backgroundImage = '';
            }
            cards.forEach((card, i) => card.classList.toggle("active", i === index));
        }

        function next() {
            index = (index + 1) % SLIDE_COUNT;
            render();
        }

        function start() {
            if (timer) return;
            render();
            timer = setInterval(next, INTERVAL_MS);
        }

        preload(getPreloadImages(true)).then(start);
        preload(getPreloadImages(false));

        const onResize = () => render();
        window.addEventListener("resize", onResize);

        cards.forEach(function(card) {
            card.addEventListener('click', function() {
                const scroll_to_bottom = card.dataset.scrollToBottom === "true";
                if (scroll_to_bottom) {
 //               selected-filters-slider-container
                    const target = document.getElementById('shopify-section-template--27296164577593__main');
                    if (target) {
                        const offset = 80;
                        const top = target.getBoundingClientRect().top + window.scrollY - offset;
                        window.scrollTo({ top, behavior: 'smooth' });
                    } else {
                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                    }
                    return;
                }
                const url = card.dataset.url;
                if (url && url !== '#') {
                    window.location.href = url;
                    return;
                }
                const target = document.getElementById('shopify-section-template--27296164577593__main');
                if (target) {
                    const offset = 80;
                    const top = target.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                }
            });
        });

        const onUnload = function(e) {
            if (e.detail.sectionId === sectionId) {
                clearInterval(timer);
                window.removeEventListener('resize', onResize);
                document.removeEventListener('shopify:section:unload', onUnload);
            }
        };
        document.addEventListener('shopify:section:unload', onUnload);
    });
}

if (document.readyState !== 'loading') {
    initHeroBanners();
} else {
    document.addEventListener("DOMContentLoaded", initHeroBanners);
}

document.addEventListener('shopify:section:load', function(e) {
    initHeroBanners();
});

(function() {
    var VIDEO_SRC = 'https://image.shoplc.com/Web/Custom_PDP/shopify-lgd-2026/v/Luxuriant-Black-vs-White-1%20(1).mp4';
    var DELAY_MS = 5000;
    var FADE_MS = 850;

    function injectVideo() {
        if (window.innerWidth > 767) return;
        var img = document.querySelector('.dynamic-mobile-video');
        if (!img || img.dataset.videoInjected) return;
        img.dataset.videoInjected = '1';

        var container = img.parentNode;
        var video = document.createElement('video');
        video.className = 'hero-bg-video';
        // Set as HTML attributes — required for Safari to honour muted + autoplay
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', ''); // older iOS Safari
        // Mirror as JS properties for other browsers
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'auto';
        video.poster = img.currentSrc || img.src;
        video.src = VIDEO_SRC;

        // Insert invisible (opacity:0) so it can buffer under the poster
        container.appendChild(video);
        video.load();

        function reveal() {
            if (video.dataset.revealed) return;
            video.dataset.revealed = '1';

            video.play().catch(function() {});

            requestAnimationFrame(function() {
                video.classList.add('is-visible');
                img.classList.add('is-fading');
            });

            setTimeout(function() {
                if (img.parentNode) img.parentNode.removeChild(img);
                video.classList.add('is-settled');
            }, FADE_MS);
        }

        function revealWhenReady() {
            if (video.readyState >= 2) {
                reveal();
                return;
            }

            var done = false;
            function finish() {
                if (done) return;
                done = true;
                reveal();
            }

            video.addEventListener('loadeddata', finish, { once: true });
            video.addEventListener('canplay', finish, { once: true });
            // Don't leave the poster stuck if media events never fire
            setTimeout(finish, 2500);
        }

        setTimeout(revealWhenReady, DELAY_MS);
    }

    if (document.readyState !== 'loading') {
        injectVideo();
    } else {
        document.addEventListener('DOMContentLoaded', injectVideo);
    }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-tv-missed-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var section = document.querySelector('.live-tv-missed-products');
  if (!section) return;

  // Tab switching
  section.querySelectorAll('.live-tv-missed-products__tab').forEach(function(tab){
    tab.addEventListener('click', function(){
      var blockId = tab.dataset.blockId;
      section.querySelectorAll('.live-tv-missed-products__tab').forEach(function(t){ t.classList.remove('live-tv-missed-products__tab--active'); t.setAttribute('aria-selected', 'false'); });
      tab.classList.add('live-tv-missed-products__tab--active');
      tab.setAttribute('aria-selected', 'true');

      section.querySelectorAll('.live-tv-missed-products__panel').forEach(function(panel){
        if (panel.dataset.blockId === blockId) {
          panel.classList.add('live-tv-missed-products__panel--active');
          
          // Force layout check for mobile
          const staticHosts = panel.querySelector('.live-tv-static-hosts');
          if (staticHosts) {
            if (panel.dataset.layoutType !== 'hosts_and_products') {
              staticHosts.style.display = 'none';
            } else {
              staticHosts.style.display = ''; // Restore default (flex)
            }
          }
        } else {
          panel.classList.remove('live-tv-missed-products__panel--active');
        }
      });
    });
  });

  // Keyboard support for the tablist (WCAG 2.1.1 / ARIA tabs pattern).
  var tvTabs = Array.prototype.slice.call(section.querySelectorAll('.live-tv-missed-products__tab'));
  tvTabs.forEach(function(tab, i){
    tab.addEventListener('keydown', function(e){
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tvTabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tvTabs.length) % tvTabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tvTabs.length - 1;
      if (next === null) return;
      e.preventDefault();
      tvTabs[next].click();
      tvTabs[next].focus();
    });
  });

  // Host click -> filter products
  section.addEventListener('click', function(e){
    var hostCard = e.target.closest('.live-tv-host-card');
    if (!hostCard) return;
    var hostTag = hostCard.dataset.hostTag;
    var panel = hostCard.closest('.live-tv-missed-products__panel');
    if (!panel) return;
    var productGrid = panel.querySelector('.live-tv-missed-products__products');
    if (!productGrid) return;

    // toggle active state
    hostCard.classList.toggle('live-tv-host-card--active');
    var active = hostCard.classList.contains('live-tv-host-card--active');

    // If activated: hide products that do not contain hostTag; if deactivated: show all
    productGrid.querySelectorAll('.live-tv-product-card').forEach(function(card){
      var tags = (card.dataset.hostTags || '').split(',');
      if (!active) {
        card.style.display = '';
      } else {
        if (tags.indexOf(hostTag) === -1) {
          card.style.display = 'none';
        } else {
          card.style.display = '';
        }
      }
    });
  });
});

// Static hosts left / right arrow scrolling
document.addEventListener('DOMContentLoaded', function () {
  const staticHosts = document.querySelector('.live-tv-static-hosts');
  if (!staticHosts) return;

  const viewport = staticHosts.querySelector('.live-tv-static-hosts__viewport');
  const leftArrow = staticHosts.querySelector('.live-tv-static-hosts__arrow--left');
  const rightArrow = staticHosts.querySelector('.live-tv-static-hosts__arrow--right');

  if (!viewport || !leftArrow || !rightArrow) return;

  const SCROLL_AMOUNT = 200; // approx one host card width

  leftArrow.addEventListener('click', function () {
    viewport.scrollBy({
      left: -SCROLL_AMOUNT,
      behavior: 'smooth'
    });
  });

  rightArrow.addEventListener('click', function () {
    viewport.scrollBy({
      left: SCROLL_AMOUNT,
      behavior: 'smooth'
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.live-tv-missed-products');
  if (!section) return;

  // Make static host filters keyboard-operable (Enter/Space) without changing visuals.
  section.querySelectorAll('.live-tv-static-hosts__item').forEach(function (item) {
    if (!item.hasAttribute('role')) item.setAttribute('role', 'button');
    if (!item.hasAttribute('tabindex')) item.setAttribute('tabindex', '0');
  });
  section.addEventListener('keydown', function (e) {
    const hostItem = e.target.closest('.live-tv-static-hosts__item');
    if (!hostItem) return;
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      hostItem.click();
    }
  });

  // Handle static host click (triangle + active state)
  section.addEventListener('click', function (e) {
    const hostItem = e.target.closest('.live-tv-static-hosts__item');
    if (!hostItem) return;

    const hostsContainer = hostItem.closest('.live-tv-static-hosts__list');
    if (!hostsContainer) return;

    // 1. Remove active class from all hosts
    hostsContainer
      .querySelectorAll('.live-tv-static-hosts__item--active')
      .forEach(function (item) {
        item.classList.remove('live-tv-static-hosts__item--active');
      });

    // 2. Add active class to clicked host
    hostItem.classList.add('live-tv-static-hosts__item--active');

    // 3. Ensure triangle element exists (if not already in static HTML)
    if (!hostItem.querySelector('.live-tv-static-hosts__active-triangle')) {
      const triangle = document.createElement('div');
      triangle.className = 'live-tv-static-hosts__active-triangle';
      hostItem.appendChild(triangle);
    }
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-tv-section-home-d"] && !Shopify.designMode) return;
  try {
    
  // Live TV video facade.
  // The video is this section's primary content, so it auto-starts (muted) as soon
  // as the block is in the DOM — muted is required for autoplay without a user
  // gesture. A user click loads it un-muted. The swap is idempotent and re-runs on
  // section re-render (theme editor) and bfcache restore, so it can never get stuck
  // showing only the poster (previously it was gated behind a one-shot
  // IntersectionObserver that could go stale / never fire below the fold).
  function loadLiveTvFacade(btn, muted) {
    if (!btn || btn.dataset.ytLoaded) return;
    var id = btn.getAttribute('data-video-id');
    if (!id) return;
    btn.dataset.ytLoaded = '1';

    var iframe = document.createElement('iframe');
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' + id +
      '?autoplay=1&rel=0&playsinline=1' + (muted ? '&mute=1' : '');
    iframe.title = btn.getAttribute('aria-label') || 'Live TV';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
    );
    iframe.allowFullscreen = true;

    var wrap = btn.parentNode;
    if (wrap) wrap.replaceChild(iframe, btn);
    return iframe;
  }

  // Immediate, un-muted play on user click (only fires while a facade is present).
  // Bound once at document level, even if this script runs again on section reload.
  if (!window.__liveTvFacadeClickBound) {
    window.__liveTvFacadeClickBound = true;
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.live-tv-content-block__video-facade[data-yt-facade]');
      if (!btn) return;
      var iframe = loadLiveTvFacade(btn, false);
      if (iframe) iframe.focus();
    });
  }

  // Auto-start every facade (muted) as soon as it is in the DOM. Idempotent: the
  // per-button data-yt-loaded guard makes re-runs a no-op once a player is swapped in.
  function startLiveTvFacades() {
    var facades = document.querySelectorAll('.live-tv-content-block__video-facade[data-yt-facade]');
    for (var i = 0; i < facades.length; i++) loadLiveTvFacade(facades[i], true);
  }

  if (document.readyState !== 'loading') {
    startLiveTvFacades();
  } else {
    document.addEventListener('DOMContentLoaded', startLiveTvFacades);
  }
  // Re-run when Shopify re-renders the section (theme editor) or on bfcache restore,
  // so a freshly-injected facade never sits stuck on its poster.
  document.addEventListener('shopify:section:load', startLiveTvFacades);
  window.addEventListener('pageshow', startLiveTvFacades);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-2"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
